import { render } from "./InputCategory.vue?vue&type=template&id=72b404f1"
import script from "./InputCategory.vue?vue&type=script&lang=js"
export * from "./InputCategory.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__